let currentLimit = 10;

function getStep() {
    if (currentLimit === 20 || currentLimit === 30 || currentLimit === 45 || currentLimit === 60) {
        return 5;
    }
    return 1;
}

function isDiscoveryKit() {
    const selectedVariantInput = document.querySelector('.m-product-option__input:checked');
    if (selectedVariantInput) {
        const parentNode = selectedVariantInput.closest('.m-product-option--node');
        if (parentNode) {
            return parentNode.getAttribute('data-value') === "Discovery Kit";
        }
    }
    return false;
}

function getDiscoveryKitQty(input) {
    const form = input.closest('form') || input.closest('product-form');
    if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput && (variantInput.value === '55915635212623' || variantInput.value === '55915695014223')) {
            return 1;
        }
    }
    return 1;
}


function getSelectedPackPrefix() {
    const selectedPackInput = document.querySelector('.block__pack_of_size input[type="radio"]:checked');
    const packName = selectedPackInput?.dataset?.packName || '';
    return packName.trim().toLowerCase();
}

function getDefaultVisiblePlanOption(select) {
    const options = Array.from(select.options || []);
    const firstSubscriptionOption = options.find(option => {
        const isOneTime = (option.dataset.frequency || '').toLowerCase() === 'one-time' || option.value === '';
        return !isOneTime;
    });
    return firstSubscriptionOption || options[0] || null;
}

function filterFrequencySelectOptionsByPack() {
    const packPrefix = getSelectedPackPrefix();
    if (!packPrefix) return;

    // Extract the numeric part of the pack prefix (e.g., "20" from "20 smoothies")
    const packNumber = packPrefix.match(/\d+/)?.[0] || packPrefix;

    document.querySelectorAll('.sub-plan-select, .frequency-select').forEach(select => {
        const options = Array.from(select.options || []);

        options.forEach(option => {
            const freqValue = (option.dataset.frequency || '').toLowerCase();
            const optionLabel = (option.textContent || '').trim().toLowerCase();

            const isOneTime = freqValue === 'one-time' || option.value === '' ||
                optionLabel.startsWith('eenmalig') || optionLabel.startsWith('one-time');

            // Robust matching: check if either the freq data attribute or the label contains the pack number
            const shouldKeep = isOneTime || freqValue.includes(packNumber) || optionLabel.includes(packNumber);

            if (!shouldKeep) {
                option.remove();
            }
        });
    });
}

function filterFirmhouseWidgetPlansByPack() {
    const packInputs = document.querySelectorAll('.block__pack_of_size input[type="radio"][data-pack-name][data-variant-id]');
    const widget = document.querySelector('fh-selling-plans-widget');
    packInputs.forEach(packInput => {
        const packPrefix = (packInput.dataset.packName || '').trim().toLowerCase();
        const packNumber = packPrefix.match(/\d+/)?.[0] || packPrefix;
        const variantId = (packInput.dataset.variantId || '').trim();
        if (!packPrefix || !variantId) return;

        const selectNodes = widget.querySelectorAll(
            `selling_plan_theme_integration[data-variant-id="${variantId}"] .subscription-card select`
        );
        selectNodes.forEach(select => {
            const options = Array.from(select.options || []);

            options.forEach(option => {
                const freqValue = (option.dataset.frequency || '').toLowerCase();
                const optionLabel = (option.textContent || '').trim().toLowerCase();
                const isOneTime =
                    freqValue === 'one-time' ||
                    option.value === '' ||
                    optionLabel.startsWith('eenmalig') ||
                    optionLabel.startsWith('one-time');

                const shouldKeep = isOneTime || freqValue.includes(packNumber) || optionLabel.includes(packNumber);

                if (!shouldKeep) {
                    option.remove();
                }
            });
        });
    });
    updateAvailableSellingPlansForVariantsCache();
}

function updateAvailableSellingPlansForVariantsCache() {
    const widget = document.querySelector('fh-selling-plans-widget');
    if (!widget) return;
    widget.availableSellingPlansForVariantsCache = Object.fromEntries([...widget.sellingPlanForms].map((form) => {
        const variantId = form.dataset.variantId;
        const sellingPlans = [...form.querySelectorAll('[data-selling-plan-id]')].map((element) => element.dataset.sellingPlanId);
        return [variantId, new Set(sellingPlans)];
    }));
}

function applyPackSellingPlanFilter() {
    updateAvailableSellingPlansForVariantsCache();
    filterFrequencySelectOptionsByPack();

    const packPrefix = getSelectedPackPrefix();
    if (packPrefix) {
        document.querySelectorAll('.sub-plan-select, .frequency-select').forEach(select => {
            const options = Array.from(select.options || []);
            const targetOption = options.find(option => {
                const freqValue = (option.dataset.frequency || '').toLowerCase();
                const label = (option.textContent || '').trim().toLowerCase();
                const packNumber = packPrefix.match(/\d+/)?.[0] || packPrefix;
                return freqValue.includes(packNumber) || label.includes(packNumber);
            });

            if (targetOption) {
                select.value = targetOption.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }

    const widget = document.querySelector('fh-selling-plans-widget');
    if (!widget || !widget.visibleSellingPlanForm) return;

    widget.cleanupVariantInputWatchers = widget.cleanupVariantInputObservers;
    const select = widget.visibleSellingPlanForm.querySelector('select');
    if (!select || widget.sellingPlanInputs[0].value === '') {
        return;
    }
    const defaultPlanOption = getDefaultVisiblePlanOption(select);
    if (defaultPlanOption) {
        const nextValue = defaultPlanOption.value;
        select.value = nextValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Ensure theme integration selects are also updated on variant/pack change
    const targetFrequency = defaultPlanOption ? (defaultPlanOption.textContent || '').trim() : '';
    if (targetFrequency) {
        document.querySelectorAll('selling_plan_theme_integration select, .subscription-card select').forEach(s => {
            const widgetOption = Array.from(s.options).find(opt => {
                const optFreq = (opt.textContent || '').trim().toLowerCase();
                const targetFreqLower = targetFrequency.toLowerCase();
                return optFreq === targetFreqLower || (targetFreqLower === 'one-time' && (optFreq === 'eenmalig' || optFreq === 'one-time'));
            });

            if (widgetOption && s.value !== widgetOption.value) {
                s.value = widgetOption.value;
                s.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }
}

function updateParentVariantData() {
    const flavourWrapper = document.querySelector('.block__flavour_products_list_wrapper');
    if (!flavourWrapper) return null;

    let parentVarId = null;

    // 1. From checked pack radio
    const checkedPack = document.querySelector('.block__pack_of_size input[type="radio"]:checked') ||
                        document.querySelector('variant-picker input[type="radio"]:checked') ||
                        document.querySelector('.m-product-option__input:checked');
    if (checkedPack && checkedPack.dataset && checkedPack.dataset.variantId) {
        const id = parseInt(checkedPack.dataset.variantId, 10);
        if (!isNaN(id) && id > 0) parentVarId = id;
    }

    // 2. From closest .block__pack_of_size container
    if (!parentVarId && checkedPack) {
        const packNode = checkedPack.closest('.block__pack_of_size');
        if (packNode && packNode.dataset && packNode.dataset.variantId) {
            const id = parseInt(packNode.dataset.variantId, 10);
            if (!isNaN(id) && id > 0) parentVarId = id;
        }
    }

    // 3. From main add-to-cart form input[name="id"] (ignoring flavour product cards)
    if (!parentVarId) {
        const idInput = document.querySelector('.m-product-form--main input[name="id"]') ||
                        document.querySelector('form[data-type="add-to-cart-form"]:not(.product-card-form) input[name="id"]');
        if (idInput && idInput.value && !idInput.closest('.block__flavour_products')) {
            const id = parseInt(idInput.value, 10);
            if (!isNaN(id) && id > 0) parentVarId = id;
        }
    }

    // 4. From wrapper dataset fallback
    if (!parentVarId && flavourWrapper.dataset && flavourWrapper.dataset.parentVariantId) {
        const id = parseInt(flavourWrapper.dataset.parentVariantId, 10);
        if (!isNaN(id) && id > 0) parentVarId = id;
    }

    // 4. From variant picker script
    if (!parentVarId) {
        const variantPicker = document.querySelector('variant-picker');
        if (variantPicker) {
            const selectedVariantScript = variantPicker.querySelector('script[data-selected-variant]');
            if (selectedVariantScript) {
                try {
                    const variantData = JSON.parse(selectedVariantScript.textContent);
                    if (variantData && variantData.id) {
                        const id = parseInt(variantData.id, 10);
                        if (!isNaN(id) && id > 0) parentVarId = id;
                    }
                } catch (e) {}
            }
        }
    }

    // 5. From URL param ?variant=
    if (!parentVarId) {
        const urlVariant = new URLSearchParams(window.location.search).get('variant');
        if (urlVariant) {
            const id = parseInt(urlVariant, 10);
            if (!isNaN(id) && id > 0) parentVarId = id;
        }
    }

    if (parentVarId) {
        flavourWrapper.dataset.parentVariantId = parentVarId;
    }

    return parentVarId;
}

window.limit = function (value) {
    // Parsing value in case it is passed as a string
    currentLimit = parseInt(value) || 10;

    // Update target display
    const target = document.querySelector('.block__limit_traget');
    if (target) target.textContent = currentLimit;

    updateParentVariantData();

    // Reset all quantity inputs
    const inputs = document.querySelectorAll('.qty-control input.quantity-selector');
    inputs.forEach(input => {
        input.value = isDiscoveryKit() ? getDiscoveryKitQty(input) : 0;
    });

    // Recalculate states immediately
    updateState();
    // Dispatch event to notify limit change
    window.dispatchEvent(new CustomEvent('limit:changed', { detail: { limit: currentLimit } }));
}

function updateState() {
    const inputs = document.querySelectorAll('.qty-control input.quantity-selector');
    let total = 0;

    // Calculate total
    inputs.forEach(input => {
        total += parseInt(input.value) || 0;
    });

    if (isDiscoveryKit()) {
        total = currentLimit;
    }

    // Update Goal Display
    const goalDiv = document.querySelector('.block__limit_goal');
    if (goalDiv) goalDiv.textContent = total;

    // Calculate remaining
    const remaining = currentLimit - total;

    // Update Max attributes for all inputs to enforce limit via main-product.liquid logic
    inputs.forEach(input => {
        const currentVal = parseInt(input.value) || 0;
        let newMax = currentVal + (remaining > 0 ? remaining : 0);

        // Also respect any hard cap (like 9999) if needed, but usually pack limit is the constraints.
        input.setAttribute('max', newMax);

        // Optional: Visual feedback if buttons need disabled state styling
        // main-product.liquid logic only checks max on click. 
        // If we want to visually disable the plus button:
        const control = input.closest('.qty-control');
        if (control) {
            const plusBtn = control.querySelector('.plus');
            const minusBtn = control.querySelector('.minus');
            const step = getStep();

            if (plusBtn) {
                // Disable plus if remaining is less than the step or it's a discovery kit
                plusBtn.disabled = (remaining < step) || isDiscoveryKit();
                if (plusBtn.disabled) plusBtn.setAttribute('disabled', 'disabled');
                else plusBtn.removeAttribute('disabled');
            }
            if (minusBtn) {
                // Disable minus if individual product qty is 0 or it's a discovery kit
                minusBtn.disabled = (currentVal <= 0) || isDiscoveryKit();
                if (minusBtn.disabled) minusBtn.setAttribute('disabled', 'disabled');
                else minusBtn.removeAttribute('disabled');
            }
        }

        // Enable/disable individual add-to-cart button based on quantity
        const form = input.closest('form') || input.closest('product-form');
        if (form) {
            const addBtn = form.querySelector('button[name="add"]');
            if (addBtn) {
                // If product is sold out, we shouldn't enable it. We check if the button text contains "Sold out" or similar logic
                const isSoldOut = addBtn.hasAttribute('disabled') && currentVal === 0 && !addBtn.classList.contains('m-spinner-button--loading');
                if (currentVal > 0) {
                    // Only enable if it's not structurally sold out, but since plus wouldn't work easily if we had stock checks,
                    // we'll just safely remove disabled. 
                    addBtn.disabled = false;
                } else {
                    addBtn.disabled = true;
                }
            }
        }
    });

    const addBtns = document.querySelectorAll('.add-btn');
    addBtns.forEach(btn => {
        if (remaining <= 0) {
            btn.disabled = true;
        } else {
            btn.disabled = false;
        }
    });

    const choosePackBtn = document.querySelector('.block_choose_pack_button');
    if (choosePackBtn) {
        const textInCart = choosePackBtn.dataset.inCartText || 'In winkelwagen';
        const textAdd = choosePackBtn.dataset.addText || 'Voeg';
        const textFlavours = choosePackBtn.dataset.flavoursText || 'smaken toe';
        const textSpan = choosePackBtn.querySelector('.m-button-text');

        if (remaining === 0) {
            choosePackBtn.removeAttribute('disabled');
            choosePackBtn.disabled = false;
            if (textSpan) {
                textSpan.textContent = textInCart;
            } else {
                choosePackBtn.textContent = textInCart;
            }
        } else {
            choosePackBtn.setAttribute('disabled', 'disabled');
            choosePackBtn.disabled = true;
            if (textSpan) {
                textSpan.textContent = `${textAdd} ${remaining} ${textFlavours}`;
            } else {
                choosePackBtn.textContent = `${textAdd} ${remaining} ${textFlavours}`;
            }
        }
    }

    if (remaining < 0) {
    }

    // Update the hidden input with all selected products and their quantities
    logAllProducts();
}

/**
 * Collects all products with quantity > 0 and updates the hidden input field
 * for properties[Contains] with a comma-separated string.
 */
function logAllProducts() {
    const inputEl = document.querySelector('.block__combo_product_list_input');
    if (!inputEl) return;

    // Scope the search to the current block to avoid finding duplicates in mobile/desktop clones
    const container = inputEl.closest('.main-product__block-custom_combo') || document;
    const flavourRows = container.querySelectorAll('.product.block__flavour_products');
    const allProducts = [];

    flavourRows.forEach(product => {
        const nameEl = product.querySelector('.block__flavour_products__title');
        const qtyEl = product.querySelector('input.quantity-selector');

        if (nameEl && qtyEl) {
            const name = nameEl.innerText.trim();
            const rawQty = parseInt(qtyEl.value, 10);
            if (rawQty > 0) {
                const qty = isDiscoveryKit() ? rawQty : Math.ceil(rawQty / 5);
                allProducts.push(`${name} Quantity: ${qty}`);
            }
        }
    });

    if (inputEl) {
        // Use semicolon for better separation in the popup and compatibility with Liquid split
        inputEl.value = allProducts.join(' ; ');
        // Trigger change event to ensure any listening scripts are notified
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // Initial update
    const selectedPack = document.querySelector('.block__pack_of_size input:checked');
    if (selectedPack) {
        const wrapper = selectedPack.closest('.block__pack_of_size');
        if (wrapper && wrapper.dataset.limit) {
            currentLimit = parseInt(wrapper.dataset.limit) || 20;
            const target = document.querySelector('.block__limit_traget');
            if (target) target.textContent = currentLimit;
        }
    }
    updateParentVariantData();

    const inputs = document.querySelectorAll('.qty-control input.quantity-selector');
    if (isDiscoveryKit()) {
        inputs.forEach(input => input.value = getDiscoveryKitQty(input));
    }
    updateState();

    // Trigger price display setup on load
    const initialPurchaseOption = document.querySelector('input[name^="purchaseOption"]:checked');
    if (initialPurchaseOption) {
        initialPurchaseOption.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Initialize nutrition table toggle
    initNutritionTableToggle();

    // Listen for events
    document.addEventListener('click', (e) => {
        if (e.target.closest('.plus') || e.target.closest('.minus') || e.target.closest('.add-btn')) {
            // Wait for partial updates (if any sync logic runs) then update state
            setTimeout(updateState, 10);
        }

        // Add all selected flavor products to cart via Shopify Nested Cart Lines
        if (e.target.closest('.block_choose_pack_button')) {
            e.preventDefault();
            const btn = e.target.closest('.block_choose_pack_button');
            if (btn.disabled || btn.classList.contains('loading')) return;

            const itemsToCart = [];
            const bundleId = Date.now().toString();

            // 1. Resolve parent pack variant ID using multi-tier fallback
            let mainVariantId = updateParentVariantData();
            if (!mainVariantId) {
                const flavourWrapper = document.querySelector('.block__flavour_products_list_wrapper');
                if (flavourWrapper && flavourWrapper.dataset && flavourWrapper.dataset.parentVariantId) {
                    const parsed = parseInt(flavourWrapper.dataset.parentVariantId, 10);
                    if (!isNaN(parsed) && parsed > 0) mainVariantId = parsed;
                }
            }

            // Target ONLY the main product form, NEVER flavour cards inside .block__flavour_products
            const mainForm = Array.from(document.querySelectorAll('.m-product-form--main form, form[data-type="add-to-cart-form"]'))
                .find(f => !f.closest('.block__flavour_products') && !f.classList.contains('product-card-form'));

            if (mainForm && !mainVariantId) {
                const idInput = mainForm.querySelector('input[name="id"]');
                if (idInput && idInput.value) {
                    const parsed = parseInt(idInput.value, 10);
                    if (!isNaN(parsed) && parsed > 0) mainVariantId = parsed;
                }
            }

            if (!mainVariantId) {
                console.error("Could not determine main pack variant ID.");
                alert("Er is iets misgegaan bij het selecteren van het pakket. Vernieuw de pagina en probeer het opnieuw.");
                return;
            }

            // Determine parent pack quantity:
            // Custom combo packs are 1 bundle. If a dedicated main product quantity selector exists (NOT in flavour cards), use it.
            let parentPackQty = 1;
            const mainQtyInput = document.querySelector('.main-product__block-buy_buttons input[name="quantity"], .m-product-form--main input[name="quantity"], input.m-quantity__input:not(.block__flavour_products input)');
            if (mainQtyInput && !mainQtyInput.closest('.block__flavour_products')) {
                const parsedQty = parseInt(mainQtyInput.value, 10);
                if (!isNaN(parsedQty) && parsedQty > 0) {
                    parentPackQty = parsedQty;
                }
            }

            // Determine selling_plan for the main pack (if subscription)
            let mainSellingPlan = null;
            if (!isDiscoveryKit()) {
                const mainSellingPlanInput = mainForm ? mainForm.querySelector('input[name="selling_plan"]') : null;
                const fhWidget = document.querySelector('fh-selling-plans-widget');
                if (mainSellingPlanInput && mainSellingPlanInput.value && mainSellingPlanInput.value !== "" && !mainSellingPlanInput.closest('.block__flavour_products')) {
                    mainSellingPlan = parseInt(mainSellingPlanInput.value, 10) || null;
                } else if (fhWidget) {
                    let spInput = (fhWidget.sellingPlanInputs && fhWidget.sellingPlanInputs[0]) ||
                                  (fhWidget.visibleSellingPlanForm && fhWidget.visibleSellingPlanForm.querySelector('input[name="selling_plan"], select')) ||
                                  document.querySelector('fh-selling-plans-widget input[name="selling_plan"]') ||
                                  document.querySelector('input[name="selling_plan"].selected-selling-plan-id');
                    if (spInput && spInput.value) {
                        mainSellingPlan = parseInt(spInput.value, 10) || null;
                    }
                }
                if (!mainSellingPlan && window.currentSelectedSellingPlan) {
                    mainSellingPlan = parseInt(window.currentSelectedSellingPlan, 10) || null;
                }
                if (!mainSellingPlan) {
                    const firstFlavourSelect = document.querySelector('.block__flavour_products select.sub-plan-select');
                    if (firstFlavourSelect && firstFlavourSelect.value) {
                        mainSellingPlan = parseInt(firstFlavourSelect.value, 10) || null;
                    }
                }
            }

            // Add the Parent Pack Item with guaranteed correct pack quantity
            const mainItem = {
                id: mainVariantId,
                quantity: parentPackQty,
                properties: {
                    _bundleId: bundleId
                }
            };

            // Ensure properties[Contains] is generated and accurately set
            logAllProducts();
            const comboInput = document.querySelector('.block__combo_product_list_input');
            if (comboInput && comboInput.value) {
                mainItem.properties['Contains'] = comboInput.value;
            }

            // Extract any other custom line item properties (excluding flavour product inputs)
            const propertyInputs = document.querySelectorAll(
                'input[name^="properties["]:not(.block__combo_product_list_input):not(.block__flavour_products input), select[name^="properties["]:not(.block__flavour_products select), textarea[name^="properties["]'
            );
            propertyInputs.forEach(input => {
                const nameMatch = input.name.match(/properties\[(.*?)\]/);
                if (nameMatch && nameMatch[1] && input.value) {
                    mainItem.properties[nameMatch[1]] = input.value;
                }
            });

            if (mainSellingPlan) {
                mainItem.selling_plan = mainSellingPlan;
            }
            itemsToCart.push(mainItem);

            // Add child flavor products to cart (hidden in cart drawer/page via block__cart_flavour-product_none)
            if (!isDiscoveryKit()) {
                const flavourRows = document.querySelectorAll('.product.block__flavour_products');
                if (flavourRows.length > 0) {
                    flavourRows.forEach(row => {
                        const qtyInput = row.querySelector('.qty-control input.quantity-selector') || row.querySelector('input[name="quantity"]');
                        const rawQty = qtyInput ? (parseInt(qtyInput.value, 10) || 0) : 0;
                        if (rawQty > 0) {
                            let childVariantId = null;
                            if (row.dataset && row.dataset.variantId) {
                                childVariantId = parseInt(row.dataset.variantId, 10);
                            }
                            if (!childVariantId || isNaN(childVariantId)) {
                                const idInput = row.querySelector('input[name="id"]');
                                if (idInput && idInput.value) {
                                    childVariantId = parseInt(idInput.value, 10);
                                }
                            }
                            if (!childVariantId || isNaN(childVariantId)) {
                                const idEl = row.querySelector('.block__flavour_products__id');
                                if (idEl && idEl.textContent.trim()) {
                                    childVariantId = parseInt(idEl.textContent.trim(), 10);
                                }
                            }

                            if (childVariantId && !isNaN(childVariantId) && childVariantId > 0) {
                                const childQty = Math.ceil(rawQty / 5);
                                const childItem = {
                                    id: childVariantId,
                                    quantity: childQty,
                                    properties: {
                                        _bundleId: bundleId
                                    }
                                };
                                if (mainSellingPlan) {
                                    childItem.selling_plan = mainSellingPlan;
                                }
                                itemsToCart.push(childItem);
                            }
                        }
                    });
                } else {
                    const allInputs = document.querySelectorAll('.qty-control input.quantity-selector');
                    allInputs.forEach(input => {
                        const qty = parseInt(input.value, 10) || 0;
                        if (qty > 0) {
                            const form = input.closest('form') || input.closest('product-form') || input.closest('.product');
                            if (form) {
                                const variantInput = form.querySelector('input[name="id"]');
                                const varIdVal = variantInput ? variantInput.value : form.dataset?.variantId;
                                if (varIdVal) {
                                    const childVariantId = parseInt(varIdVal, 10);
                                    if (childVariantId && !isNaN(childVariantId) && childVariantId > 0) {
                                        const childItem = {
                                            id: childVariantId,
                                            quantity: Math.ceil(qty / 5),
                                            properties: {
                                                _bundleId: bundleId
                                            }
                                        };
                                        if (mainSellingPlan) {
                                            childItem.selling_plan = mainSellingPlan;
                                        }
                                        itemsToCart.push(childItem);
                                    }
                                }
                            }
                        }
                    });
                }
            }

            if (itemsToCart.length > 0) {
                btn.classList.add('loading', 'm-spinner-loading', 'm-spinner-button');
                btn.disabled = true;
                const originalText = btn.innerHTML;

                let spinnerEl = btn.querySelector('.m-spinner-icon');
                if (!spinnerEl) {
                    btn.innerHTML = `
                        <span class="m-spinner-icon" style="display: flex; position: static;">
                            <svg class="animate-spin m-svg-icon--medium" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" style="display: block; width: 22px; height: 22px;">
                                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </span>
                    `;
                }

                let sectionsToBundle = [];
                document.documentElement.dispatchEvent(
                    new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
                );

                const atcUrl = `${(window.Shopify?.routes?.root || '/').replace(/\/+$/, '')}/cart/add.js`;

                fetch(atcUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ items: itemsToCart, sections: sectionsToBundle })
                })
                    .then(response => {
                        return response.json().then(data => {
                            if (!response.ok) {
                                throw new Error(data.description || data.message || "Error adding to cart");
                            }
                            return data;
                        });
                    })
                    .then(data => {
                        btn.classList.remove('loading', 'm-spinner-loading');
                        btn.disabled = false;
                        btn.innerHTML = originalText;

                        // Update local inputs visually first for speed
                        const allQtyInputs = document.querySelectorAll('.qty-control input.quantity-selector');
                        allQtyInputs.forEach(input => {
                            input.value = isDiscoveryKit() ? getDiscoveryKitQty(input) : 0;
                            input.dispatchEvent(new Event('input', { bubbles: true }));
                        });
                        updateState();

                        // Fetch the section HTML natively to properly refresh server-side liquid components like data-cart-quantity
                        const productInfo = document.querySelector('product-info');
                        if (productInfo) {
                            const sectionId = productInfo.dataset.sectionId || productInfo.dataset.originalSection || document.querySelector('[data-section-id]')?.dataset?.sectionId;
                            if (sectionId) {
                                const url = `${window.location.pathname}${window.location.search}${window.location.search.includes('?') ? '&' : '?'}section_id=${sectionId}`;
                                fetch(url)
                                    .then(res => res.text())
                                    .then(html => {
                                        const parser = new DOMParser();
                                        const doc = parser.parseFromString(html, 'text/html');
                                        const newWrapper = doc.querySelector('.block__flavour_products_list_wrapper');
                                        const targetWrapper = document.querySelector('.block__flavour_products_list_wrapper');

                                        if (newWrapper && targetWrapper) {
                                            targetWrapper.replaceWith(newWrapper);
                                            // Dispatch custom event to rebind frequency-sync and other listeners
                                            document.dispatchEvent(new CustomEvent('variant:changed'));
                                        }
                                    }).catch(err => console.error("Error refreshing flavour blocks:", err));
                            }
                        }

                        // Emit standard minimog event which updates Native DOM and fires cart:updated Event
                        if (window.MinimogEvents && window.MinimogTheme) {
                            window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: data });
                        }

                        // Trigger Theme cart drawer open
                        const cartDrawer = document.querySelector('m-cart-drawer');
                        if (cartDrawer && typeof cartDrawer.open === 'function') {
                            cartDrawer.open();
                        } else {
                            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
                        }
                    })
                    .catch((error) => {
                        console.error('Error adding to cart:', error);
                        btn.classList.remove('loading', 'm-spinner-loading');
                        btn.disabled = false;
                        btn.innerHTML = originalText;
                        alert("Error adding to cart: " + error.message);
                    });
            }
        }
    });

    // Intercept standard form submission when flavour selection block is active
    document.addEventListener('submit', (e) => {
        const form = e.target.closest('form[data-type="add-to-cart-form"]') || e.target.closest('form[action*="/cart/add"]');
        if (form && document.querySelector('.block__flavour_products_list_wrapper')) {
            const customAtcBtn = document.querySelector('.block_choose_pack_button');
            if (customAtcBtn) {
                e.preventDefault();
                e.stopPropagation();
                customAtcBtn.click();
            }
        }
    }, true);

    // Synchronize parent variant on pack change
    document.addEventListener('change', (e) => {
        if (e.target.matches('.block__pack_of_size input, .m-product-option__input')) {
            updateParentVariantData();
            setTimeout(updateParentVariantData, 50);
        }
    });

    // Listen for manual input changes
    document.addEventListener('input', (e) => {
        if (e.target.matches('.qty-control input.quantity-selector')) {
            if (isDiscoveryKit()) {
                e.target.value = getDiscoveryKitQty(e.target);
            }
            updateState();
        }
    });

    // Function to handle quantity changes for packs-smoothies-btn
    function initQtyControls() {

        // Helper to update button labels
        function updateButtonLabels() {
            const step = getStep();
            // Re-query controls to ensure we get current ones
            const currentControls = document.querySelectorAll('.qty-control');
            currentControls.forEach(control => {
                const minusBtn = control.querySelector('.minus');
                const plusBtn = control.querySelector('.plus');
                if (minusBtn) minusBtn.textContent = `-${step}`;
                if (plusBtn) plusBtn.textContent = `+${step}`;
            });
        }

        // Initial label update
        updateButtonLabels();

        // Listen for limit changes (dispatched by window.limit)
        window.addEventListener('limit:changed', updateButtonLabels);

        // Global Event Delegation for Plus/Minus buttons
        // Ensure we don't add multiple listeners if this function runs again
        if (!window.qtyControlsInitialized) {
            window.qtyControlsInitialized = true;

            document.addEventListener('click', function (e) {
                const minusBtn = e.target.closest('.qty-control .minus');
                const plusBtn = e.target.closest('.qty-control .plus');

                if ((minusBtn || plusBtn) && isDiscoveryKit()) {
                    e.preventDefault();
                    return;
                }

                if (minusBtn) {
                    if (minusBtn.disabled) {
                        e.preventDefault();
                        return;
                    }
                    e.preventDefault();
                    const control = minusBtn.closest('.qty-control');
                    const input = control.querySelector('input.quantity-selector');
                    if (!input) return;

                    let currentValue = parseInt(input.value) || 0;
                    let minValue = parseInt(input.min) || 0;
                    let step = getStep();

                    if (currentValue > minValue) {
                        let newValue = currentValue - step;
                        if (newValue < minValue) newValue = minValue; // Ensure not below min
                        input.value = newValue;
                        // Trigger input event to update state immediately
                        input.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }

                if (plusBtn) {
                    if (plusBtn.disabled) {
                        e.preventDefault();
                        return;
                    }
                    e.preventDefault();
                    const control = plusBtn.closest('.qty-control');
                    const input = control.querySelector('input.quantity-selector');
                    if (!input) return;

                    let currentValue = parseInt(input.value) || 0;
                    let maxValue = parseInt(input.max) || 9999;
                    let step = getStep();

                    if (currentValue < maxValue) {
                        let newValue = currentValue + step;
                        if (newValue > maxValue) newValue = maxValue; // Ensure not above max
                        input.value = newValue;
                        // Trigger input event to update state immediately
                        input.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                }
            });
        }

        // Expose updateButtonLabels globally in case needing manual trigger
        window.updateQtyButtonLabels = updateButtonLabels;
    }

    // Initialize on load
    initQtyControls();

    // Consolidated frequency synchronization
    document.addEventListener('change', function (e) {
        if (e.target.classList.contains('sub-plan-select')) {
            if (window.isSyncingFrequencies) return;
            window.isSyncingFrequencies = true;

            const select = e.target;
            const val = select.value;
            window.currentSelectedSellingPlan = val;
            const selectedOption = select.options[select.selectedIndex];
            const targetFrequency = selectedOption ? (selectedOption.dataset.frequency || '').trim() : '';

            // 1. Sync all other flavour dropdowns by frequency name
            const allSelects = document.querySelectorAll('.sub-plan-select');
            allSelects.forEach(s => {
                if (s === select) return;

                let optionToSelect = s.querySelector(`option[data-frequency="${targetFrequency}"]`);
                // Fallback if frequency name doesn't match exactly (e.g. for One-time)
                if (!optionToSelect && (!targetFrequency || targetFrequency.toLowerCase() === 'one-time')) {
                    optionToSelect = s.querySelector('option[data-frequency="one-time"]') || s.querySelector('option[value=""]');
                }

                if (optionToSelect) {
                    s.value = optionToSelect.value;
                } else if (!targetFrequency || targetFrequency.toLowerCase() === 'one-time') {
                    // Ensure it's empty if it's one-time
                    s.value = "";
                }
            });

            // 2. Update hidden inputs for ALL flavor rows
            document.querySelectorAll('.block__flavour_products__info').forEach(wrapper => {
                const rowSelect = wrapper.querySelector('.sub-plan-select');
                const hiddenInput = wrapper.querySelector('input[name="selling_plan"]');
                if (rowSelect && hiddenInput) {
                    hiddenInput.value = rowSelect.value;
                }
            });

            // 3. Sync with main product form's selling plan input
            const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
            if (mainForm) {
                let mainSellingPlanInput = mainForm.querySelector('input[name="selling_plan"]');
                if (!mainSellingPlanInput && val) {
                    mainSellingPlanInput = document.createElement('input');
                    mainSellingPlanInput.type = 'hidden';
                    mainSellingPlanInput.name = 'selling_plan';
                    mainSellingPlanInput.className = 'selected-selling-plan-id';
                    mainForm.appendChild(mainSellingPlanInput);
                }
                if (mainSellingPlanInput) {
                    mainSellingPlanInput.value = val;
                }
            }

            // 4. Sync Firmhouse widget
            const widget = document.querySelector('fh-selling-plans-widget');
            if (widget && widget.visibleSellingPlanForm) {
                const widgetSelect = widget.visibleSellingPlanForm.querySelector('select');
                if (widgetSelect) {
                    // Find matching option in widget select by frequency name
                    const widgetOption = Array.from(widgetSelect.options).find(opt => {
                        const optFreq = (opt.textContent || '').trim().toLowerCase();
                        const targetFreqLower = targetFrequency.toLowerCase();
                        return optFreq === targetFreqLower || (targetFreqLower === 'one-time' && (optFreq === 'eenmalig' || optFreq === 'one-time'));
                    });

                    if (widgetOption) {
                        widgetSelect.value = widgetOption.value;
                    } else if (targetFrequency) {
                        // Fallback to searching by prefix or similar
                        const prefix = targetFrequency.split(' ')[0].toLowerCase();
                        const matchingOpt = Array.from(widgetSelect.options).find(opt => (opt.textContent || '').trim().toLowerCase().startsWith(prefix));
                        if (matchingOpt) widgetSelect.value = matchingOpt.value;
                    }
                    widgetSelect.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }

            // 5. Sync selling_plan_theme_integration and other subscription selects
            document.querySelectorAll('selling_plan_theme_integration select, .subscription-card select').forEach(s => {
                const widgetOption = Array.from(s.options).find(opt => {
                    const optFreq = (opt.textContent || '').trim().toLowerCase();
                    const targetFreqLower = targetFrequency.toLowerCase();
                    return optFreq === targetFreqLower || (targetFreqLower === 'one-time' && (optFreq === 'eenmalig' || optFreq === 'one-time'));
                });

                if (widgetOption && s.value !== widgetOption.value) {
                    s.value = widgetOption.value;
                    s.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });

            window.isSyncingFrequencies = false;
        }
    });


    filterFirmhouseWidgetPlansByPack();
    applyPackSellingPlanFilter();

    // Re-initialize scripts on variant change since the DOM of the section is swapped completely
    document.addEventListener('variant:changed', () => {

        const selectedPack = document.querySelector('.block__pack_of_size input:checked');
        if (selectedPack) {
            const wrapper = selectedPack.closest('.block__pack_of_size');
            if (wrapper && wrapper.dataset.limit) {
                currentLimit = parseInt(wrapper.dataset.limit) || 20;
                const target = document.querySelector('.block__limit_traget');
                if (target) target.textContent = currentLimit;
            }
        }
        updateParentVariantData();

        const inputs = document.querySelectorAll('.qty-control input.quantity-selector');
        if (isDiscoveryKit()) {
            inputs.forEach(input => input.value = getDiscoveryKitQty(input));
        } else {
            // Need to reset to 0 when not discovery kit so user can pick
            inputs.forEach(input => input.value = 0);
        }

        updateState();

        if (window.updateQtyButtonLabels) {
            window.updateQtyButtonLabels();
        }
    });
});


// Variant change to sync frequency-select
function updateFrequencyBasedOnVariant() {
    // Find the currently selected variant radio
    const selectedVariantInput = document.querySelector('.m-product-option__input:checked');
    if (selectedVariantInput) {
        const parentNode = selectedVariantInput.closest('.m-product-option--node');
        if (parentNode) {
            const variantValue = parentNode.getAttribute('data-value');
            const targetFrequency = variantValue === "Discovery Kit" ? "one-time" : "Elke maand";
            const isOneTime = targetFrequency === "one-time";

            // 1. Sync the main purchase option radios if they exist
            const purchaseOptionRadios = document.querySelectorAll('input[name^="purchaseOption"]');
            purchaseOptionRadios.forEach(radio => {
                const radioContainer = radio.closest('li');
                const radioIsOneTime = radioContainer && radioContainer.classList.contains('one-time-purchase');

                if ((isOneTime && radioIsOneTime) || (!isOneTime && !radioIsOneTime)) {
                    if (!radio.checked) {
                        radio.checked = true;
                        // Trigger change so the widget updates (e.g. shows/hides subscription select)
                        radio.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });

            // 2. Sync all flavour-level frequency selects
            const allSelects = document.querySelectorAll(".frequency-select");
            allSelects.forEach(function (select) {
                const optionToSelect = Array.from(select.options).find(opt => {
                    const freq = (opt.dataset.frequency || '').toLowerCase();
                    const label = (opt.textContent || '').trim().toLowerCase();
                    if (isOneTime) {
                        return freq === 'one-time' || label.startsWith('eenmalig') || label.startsWith('one-time');
                    } else {
                        // For subscriptions, we usually want the "first" available one if "Elke maand" isn't found
                        return freq.includes('maand') || freq.includes('month') || label.includes('maand') || label.includes('month');
                    }
                });

                if (optionToSelect) {
                    if (select.value !== optionToSelect.value) {
                        select.value = optionToSelect.value;
                        // Trigger change so that any dependent logic runs properly
                        select.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                }
            });

            // 3. Toggle the sachet discount display
            const discountedPrices = document.querySelectorAll('.discounted-price-sachet');
            const regularPrices = document.querySelectorAll('.regular-price-sachet');
            const freeProductContainer = document.querySelector('.block__free_product-container.show-free-product');
            // const freeGiftCardContainer = document.querySelector('.block__free_product-container.free_gift_card');

            if (isOneTime || isDiscoveryKit()) {
                // Show regular price, hide discounted price
                discountedPrices.forEach(el => el.style.display = 'none');
                regularPrices.forEach(el => el.style.display = 'inline');
                if (freeProductContainer) freeProductContainer.classList.remove('block__show');
            } else {
                // Show discounted price, hide regular price
                discountedPrices.forEach(el => el.style.display = 'inline');
                regularPrices.forEach(el => el.style.display = 'none');
                if (freeProductContainer) freeProductContainer.classList.add('block__show');
            }

            if (freeGiftCardContainer) {
                if (isDiscoveryKit()) {
                    freeGiftCardContainer.classList.remove('block__none');
                } else {
                    freeGiftCardContainer.classList.add('block__none');
                }
            }
        }
    }
}

// Sync individual products when "Eenmalig" or "Abonneer" is clicked
document.addEventListener('firmhouse.sellingPlanChanged', function (e) {

    const isOneTime = e.target.closest('li.one-time-purchase') !== null;

    const targetSellingPlan = isOneTime ? "" : e.detail.sellingPlanId;
    window.currentSelectedSellingPlan = targetSellingPlan;

    // ONLY target the dropdowns inside the individual flavour product rows
    const allSelects = document.querySelectorAll(".block__flavour_products .frequency-select");
    allSelects.forEach(function (select) {
        let optionToSelect = select.querySelector(`option[data-selling-plan-id="${targetSellingPlan}"]`);

        // Fallback for "One-time" if exact empty selling_plan_id not found
        if (isOneTime && !optionToSelect) {
            optionToSelect = select.querySelector('option[data-frequency="one-time"]') || select.querySelector('option[value=""]');
        }

        if (optionToSelect) {
            if (select.value !== optionToSelect.value) {
                select.value = optionToSelect.value;
                select.dispatchEvent(new Event('change', { bubbles: false }));

                // Manually sync hidden input because bubbles is false
                const wrapper = select.closest('.block__flavour_products__info');
                if (wrapper) {
                    const hiddenInput = wrapper.querySelector('input[name="selling_plan"]');
                    if (hiddenInput) {
                        hiddenInput.value = optionToSelect.value;
                    }
                }
            }
        }
    });

    // Toggle the sachet discount display based on purchase option
    const discountedPrices = document.querySelectorAll('.discounted-price-sachet');
    const regularPrices = document.querySelectorAll('.regular-price-sachet');
    const freeProductContainer = document.querySelector('.block__free_product-container.show-free-product');
    const freeGiftCardContainer = document.querySelector('.block__free_product-container.free_gift_card');

    if (isOneTime || isDiscoveryKit()) {
        discountedPrices.forEach(el => el.style.display = 'none');
        regularPrices.forEach(el => el.style.display = 'inline');
        if (freeProductContainer) freeProductContainer.classList.remove('block__show');
    } else {
        discountedPrices.forEach(el => el.style.display = 'inline');
        regularPrices.forEach(el => el.style.display = 'none');
        if (freeProductContainer) freeProductContainer.classList.add('block__show');
    }

    if (freeGiftCardContainer) {
        if (isDiscoveryKit()) {
            freeGiftCardContainer.classList.remove('block__none');
        } else {
            freeGiftCardContainer.classList.add('block__none');
        }
    }

});

document.addEventListener('change', function (e) {
    if (e.target.matches('input[name^="purchaseOption"]')) {
        const radioContainer = e.target.closest('li');
        const isOneTime = radioContainer && radioContainer.classList.contains('one-time-purchase');

        const discountedPrices = document.querySelectorAll('.discounted-price-sachet');
        const regularPrices = document.querySelectorAll('.regular-price-sachet');
        const freeProductContainer = document.querySelector('.block__free_product-container.show-free-product');
        const freeGiftCardContainer = document.querySelector('.block__free_product-container.free_gift_card');

        if (isOneTime || isDiscoveryKit()) {
            discountedPrices.forEach(el => el.style.display = 'none');
            regularPrices.forEach(el => el.style.display = 'inline');
            if (freeProductContainer) freeProductContainer.classList.remove('block__show');
        } else {
            discountedPrices.forEach(el => el.style.display = 'inline');
            regularPrices.forEach(el => el.style.display = 'none');
            if (freeProductContainer) freeProductContainer.classList.add('block__show');
        }

        if (freeGiftCardContainer) {
            if (isDiscoveryKit()) {
                freeGiftCardContainer.classList.remove('block__none');
            } else {
                freeGiftCardContainer.classList.add('block__none');
            }
        }
    }
});

document.addEventListener('variant:changed', () => {
    setTimeout(() => {
        applyPackSellingPlanFilter();
    }, 50);
    initNutritionTableToggle();
});

function initNutritionTableToggle() {
    const select = document.querySelector('.block_nutrition_table_select');
    const tables = document.querySelectorAll('.block__Nutrition_table_con');

    if (select && tables.length > 0) {
        select.removeEventListener('change', handleNutritionChange);
        select.addEventListener('change', handleNutritionChange);

        handleNutritionChange.call(select);
    }
    function handleNutritionChange() {
        const selectedValue = this.value;
        if (!selectedValue) return;

        const tableClass = 'block__' + selectedValue.toLowerCase().replace(/ /g, '_') + '_table';

        tables.forEach(table => {
            table.classList.remove('active');
        });
        const activeTable = document.querySelector('.' + tableClass);
        if (activeTable) {
            activeTable.classList.add('active');
        }
    }
}

